<template>
    <div class="page-login">
        <div class="login-content" v-loading.body="popupLoading">
            <el-row class="header">
                <el-col :span="8" class="header-logo">
                    <div class="eg-logo"></div>
                </el-col>
                <el-col :span="8" class="header-title">{{ $t('loginEgAccount') }}</el-col>
                <el-col :span="8" class="header-close">
                    <i class="el-icon-close" @click="closeLoginPopup"></i>
                </el-col>
            </el-row>
            <div class="content">
                <div class="input-group">
                    <div class="input-content">
                        <i class="fa fa-user left-icon"></i>
                        <input class="middle-input" type="text" :placeholder="$t('inputAccount')" v-model="form.account">
                    </div>
                    <div class="input-message" v-if="submitClicked && !form.account">{{ $t('accountNotEmpty') }}</div>
                </div>
                <div class="input-group">
                   <div class="input-content">
                       <i class="fa fa-lock left-icon"></i>
                       <input class="middle-input" type="password" :placeholder="$t('inputPassword')" v-model="form.password">
                   </div>
                    <div class="input-message" v-if="submitClicked && !form.password">{{ $t('passwordNotEmpty') }}</div>
                </div>
                <!--<div class="input-group">-->
                  <!--<div id="recaptcha" class="g-recaptcha"></div>-->
                <!--</div>-->
                <el-checkbox v-model="checked" class="check-btn">{{ $t('rememberAccount') }}</el-checkbox>
                <el-button type="primary" class="login-btn" @click="submit">{{ $t('login') }}</el-button>
            </div>
        </div>
    </div>
</template>


<script>
    import {USER_LOGIN} from '../../store/mutation-types'
    import {MessageBox} from 'element-ui';

    export default {
        data() {
            return {
                submitClicked: false,
                popupLoading: false,
                capCode: ['', '', '', ''],
                form: {
                    account: "",
                    password: "",
                    // code: ""
                },
                codeStyle: {c1: {}, c2: {}, c3: {}, c4: {}},
                codeBg: {},
                checked: false,

            }
        },
        computed: {
            loginPath() {
                return this.$store.state.loginPath;
            }
        },
        mounted: function() {
          // this.initReCaptcha();
        },
        methods: {
            // initReCaptcha: function() {
            //     var self = this;
            //     setTimeout(function() {
            //         if(typeof grecaptcha === 'undefined') {
            //             self.initReCaptcha();
            //         }
            //         else {
            //             grecaptcha.render('recaptcha', {
            //                 sitekey: '6Ld7W0QUAAAAAEWRP_LEWAnolEIVFslq7WgZs0pi',
            //                 badge: 'inline',
            //                 callback: self.codeBack
            //             });
            //         }
            //     }, 100);
            // },
            // codeBack(res) {
            //     this.form.code = res;
            // },
            disableBg() {
                document.body.style.overflowY = 'scroll';
                document.body.style.position = 'fixed';
            },
            enableBg() {
                document.body.style.overflowY = 'auto';
                document.body.style.position = 'static';
            },
            popupMessage(content, title) {
                this.disableBg();
                const that = this;
                this.$alert(content, title, {
                    callback: function () {
                        that.enableBg();
                    }
                });
            },
            submit() {
                this.submitClicked = true;
                // if(this.form.code && this.form.account && this.form.password) {
                if(this.form.account && this.form.password) {
                    const that = this;
                    this.popupLoading = true;
                    this.$store.dispatch([USER_LOGIN], this.form).then(function () {
                        that.popupLoading = true;
                        that.enableBg();
                        that.$store.commit('controlLoginPopup', false);
                        that.$store.commit('getTotalEg');
                        if (that.loginPath) {
                            that.$router.replace({path: that.loginPath});
                        } else {
                            that.$router.replace({path: '/store'});
                        }
                    }).catch(function (errorCode) {
                        that.popupLoading = true;
                        that.enableBg();
                        that.$store.commit('controlLoginPopup', false);
                        switch (errorCode) {
                            // case -1:
                            //     that.popupMessage(that.$t('captchaError'), that.$t('loginFail'));
                            //     break;
                            case 2002:
                                that.popupMessage(that.$t('userNotExits'), that.$t('loginFail'));
                                break;
                            case 2007:
                                that.popupMessage(that.$t('passwordError'), that.$t('loginFail'));
                                break;
                            default:
                                that.popupMessage(that.$t('loginFailErrorCode') + errorCode, that.$t('loginFail'));
                        }
                        that.$router.replace({path: '/store'});
                    });
                }
            },
            // getRandomChar() {
            //     const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            //     return possible.charAt(Math.floor(Math.random() * possible.length));
            // },
            // generateCaptchaCode () {
            //     this.btn = false;
            //     this.form.code = '';
            //     this.capCode[0] = this.getRandomChar();
            //     this.capCode[1] = this.getRandomChar();
            //     this.capCode[2] = this.getRandomChar();
            //     this.capCode[3] = this.getRandomChar();
            //     this.setCodeStyle();
            //     this.randomBackgroundPosition();
            // },
            // updateCode() {
            //     this.generateCaptchaCode();
            // },
            closeLoginPopup() {
                this.$store.commit('controlLoginPopup', false);
            },
            setCodeStyle() {
                this.codeStyle = {
                    c1: {
                        fontSize: this.randomFontSize(),
                        marginTop: this.randomMarginTop(),
                        transform: this.randomRotate()
                    },
                    c2: {
                        fontSize: this.randomFontSize(),
                        marginTop: this.randomMarginTop(),
                        transform: this.randomRotate()
                    },
                    c3: {
                        fontSize: this.randomFontSize(),
                        marginTop: this.randomMarginTop(),
                        transform: this.randomRotate()
                    },
                    c4: {
                        fontSize: this.randomFontSize(),
                        marginTop: this.randomMarginTop(),
                        transform: this.randomRotate()
                    }
                };
                this.codeBg = {
                    backgroundPosition: '50px 130px'
                };
            },
            randomFontSize () {
                return Math.floor(Math.random() * 6 + 22) + 'px';
            },
            randomMarginTop () {
                let sign = Math.round(Math.random() * 100) % 2 == 0 ? '' : '-';
                return sign + Math.floor(Math.random() * 5 + 4) + 'px';
            },
            randomRotate () {
                let sign = Math.round(Math.random() * 100) % 2 == 0 ? '' : '-';
                let deg = sign + Math.floor(90 - Math.random() * 90) / 3 + 'deg';
                return 'rotate(' + deg + ')';
            },
            randomBackgroundPosition () {
                let width = 571;
                let height = 100;
                let x = Math.floor(1 - Math.random() * width) + 'px';
                let y = Math.floor(1 - Math.random() * height) + 'px';
                this.codeBg = {
                    backgroundPosition: x + ' ' + y
                };
            }
        },
        // created() {
        //     this.generateCaptchaCode();
        // }
    }
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .page-login {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
        background: rgba(0, 0, 0, 0.5);
        @include flex-row-center;
    }

    .login-content {
        width: 355px;
        background: #fff;
        .header {
            height: 52px;
            width: 100%;
            background: #f7f7f7;
            @include flex-grow(0);
            @include flex-row-center;
            padding: 0 15px;
        }
        .content {
            @include flex-grow(1);
            height: calc(100% - 52px);
            padding: 32px 21px;
            overflow: hidden;
        }
    }

    .header-logo {
        height: 100%;
        @include flex;
        @include cross-center;
        .eg-logo {
            $logo-height: 22px;
            $logo-width: 237 / 48 * $logo-height;
            width: $logo-width;
            height: $logo-height;
            background: url("../../../static/img/nav/footer_logo.png") no-repeat top center;
            background-size: $logo-width $logo-height;
        }
    }

    .header-title {
        color: #666;
        @include flex-row-center;
        height: 100%;
    }

    .header-close {
        height: 100%;
        @include flex;
        @include cross-center;
        @include main-right;
        .el-icon-close {
            color: #999;
            font-weight: bolder;
            font-size: 13px;
            &:hover {
                color: #000;
            }
        }
    }

    .content {
        .input-group {
            width: 100%;
            margin-bottom: 16px;
            @include flex;
            @include dir-top;
            .input-content {
                border: 1px solid #ddd;
                @include flex-row-center;
                height: 43px;
            }
            .input-message {
                color: red;
                margin-top: 5px;
                font-size: 12px;
            }
            .fa {
                font-size: 22px;
            }
            .left-icon {
                width: 30px;
                color: #888;
                @include flex-grow(0);
                @include flex-row-center;
            }
            .input-captcha, .middle-input {
                @include flex-grow(1);
                height: 100%;
                border: none;
                font-size: 15px;
                padding-left: 10px;
                &:focus {
                    outline: none;
                }
            }
        }
        .check-btn {
            display: block;
            margin-bottom: 16px;
            width: 40%;
            .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #3f89ec !important;
            }
        }
        .login-btn {
            display: block;
            width: 100%;
            height: 47px;
            font-size: 18px;
            background-color: #3f89ec !important;
        }
    }

    .captcha {
        @include flex;
        @include cross-center;
        height: 100%;
        width: 130px;
        overflow: hidden;
        @include flex-grow(0);
        background: #f3fbfe;
        @include no-select;
        @include flex-row-center;
        .img {
            height: 30px;
            width: 100px;
            @include flex-row-center;
            color: #6f2f7c;
            font-size: 18px;
            font-weight: bolder;
            @include no-select;
            cursor: pointer;
            span {
                margin: 0 3px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Login.vue?40b1f391